import { ArcadeThemeColorsOverride } from './arcadeColors'
import { ThemeColorsOverride } from './colors'

const afterpayPalette = {
  ColorPaletteBlack: '#101010',
  ColorPaletteLightGrey: '#E8E8E8',
  ColorPaletteWhite: '#FFFFFF',
  ColorPaletteDarkGrey: '#666666',
  ColorPaletteMediumGrey: '#CCCCCC',
  ColorPaletteFadedGrey: '#F0F0F0',
  ColorPaletteDarkGreyText: '#959595',
}

export const afterpayColors: Partial<ArcadeThemeColorsOverride> = {
  // Prominent button colors
  buttonProminentBackgroundDefault: {
    light: afterpayPalette.ColorPaletteBlack,
    dark: afterpayPalette.ColorPaletteBlack,
  },
  buttonProminentBackgroundDisabled: {
    light: afterpayPalette.ColorPaletteMediumGrey,
    dark: afterpayPalette.ColorPaletteMediumGrey,
  },
  buttonProminentBackgroundHover: {
    light: afterpayPalette.ColorPaletteDarkGrey,
    dark: afterpayPalette.ColorPaletteDarkGrey,
  },
  buttonProminentBackgroundPressed: {
    light: afterpayPalette.ColorPaletteDarkGrey,
    dark: afterpayPalette.ColorPaletteDarkGrey,
  },
  buttonProminentTextDefault: {
    light: afterpayPalette.ColorPaletteWhite,
    dark: afterpayPalette.ColorPaletteWhite,
  },
  buttonProminentTextDisabled: {
    light: afterpayPalette.ColorPaletteDarkGreyText,
    dark: afterpayPalette.ColorPaletteDarkGreyText,
  },
  buttonProminentTextPressed: {
    light: afterpayPalette.ColorPaletteDarkGreyText,
    dark: afterpayPalette.ColorPaletteDarkGreyText,
  },

  // Standard button colors
  buttonStandardBackgroundDefault: {
    light: afterpayPalette.ColorPaletteLightGrey,
    dark: afterpayPalette.ColorPaletteLightGrey,
  },
  buttonStandardBackgroundDisabled: {
    light: afterpayPalette.ColorPaletteFadedGrey,
    dark: afterpayPalette.ColorPaletteFadedGrey,
  },
  buttonStandardBackgroundHover: {
    light: afterpayPalette.ColorPaletteMediumGrey,
    dark: afterpayPalette.ColorPaletteMediumGrey,
  },
  buttonStandardBackgroundPressed: {
    light: afterpayPalette.ColorPaletteMediumGrey,
    dark: afterpayPalette.ColorPaletteMediumGrey,
  },
  buttonStandardTextDefault: {
    light: afterpayPalette.ColorPaletteBlack,
    dark: afterpayPalette.ColorPaletteBlack,
  },
  buttonStandardTextDisabled: {
    light: afterpayPalette.ColorPaletteDarkGreyText,
    dark: afterpayPalette.ColorPaletteDarkGreyText,
  },

  // Subtle button colors
  buttonSubtleBackgroundDefault: {
    light: afterpayPalette.ColorPaletteWhite,
    dark: afterpayPalette.ColorPaletteWhite,
  },
  buttonSubtleBackgroundDisabled: {
    light: afterpayPalette.ColorPaletteFadedGrey,
    dark: afterpayPalette.ColorPaletteFadedGrey,
  },
  buttonSubtleBackgroundHover: {
    light: afterpayPalette.ColorPaletteFadedGrey,
    dark: afterpayPalette.ColorPaletteFadedGrey,
  },
  buttonSubtleBackgroundFocus: {
    light: afterpayPalette.ColorPaletteLightGrey,
    dark: afterpayPalette.ColorPaletteLightGrey,
  },
  buttonSubtleBackgroundPressed: {
    light: afterpayPalette.ColorPaletteLightGrey,
    dark: afterpayPalette.ColorPaletteLightGrey,
  },
  buttonSubtleTextDefault: {
    light: afterpayPalette.ColorPaletteBlack,
    dark: afterpayPalette.ColorPaletteBlack,
  },
  buttonSubtleTextDisabled: {
    light: afterpayPalette.ColorPaletteDarkGreyText,
    dark: afterpayPalette.ColorPaletteDarkGreyText,
  },
  buttonSubtleTextPressed: {
    light: afterpayPalette.ColorPaletteDarkGreyText,
    dark: afterpayPalette.ColorPaletteDarkGreyText,
  },

  // Radio button colors
  radioActiveBorderDefault: {
    light: afterpayPalette.ColorPaletteBlack,
    dark: afterpayPalette.ColorPaletteWhite,
  },
  radioActiveBorderDisabled: {
    light: afterpayPalette.ColorPaletteMediumGrey,
    dark: afterpayPalette.ColorPaletteMediumGrey,
  },

  // Checkbox button colors
  checkboxActiveBackgroundDefault: {
    light: afterpayPalette.ColorPaletteBlack,
    dark: afterpayPalette.ColorPaletteWhite,
  },
  checkboxActiveBackgroundDisabled: {
    light: afterpayPalette.ColorPaletteMediumGrey,
    dark: afterpayPalette.ColorPaletteMediumGrey,
  },

  // Input colors
  inputBorderSelectedDefault: {
    light: afterpayPalette.ColorPaletteBlack,
    dark: afterpayPalette.ColorPaletteWhite,
  },
  inputCursor: {
    light: afterpayPalette.ColorPaletteBlack,
    dark: afterpayPalette.ColorPaletteWhite,
  },
}

export const afterpayMooncakeColors = {
  primary: {
    light: afterpayPalette.ColorPaletteBlack,
    dark: afterpayPalette.ColorPaletteBlack,
  },
} as ThemeColorsOverride
